module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIUAAABkCAYAAACowvMbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAABGdBTUEAALGOfPtRkwAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAAAyElEQVR42uzSMREAAAjEsAf/nmFFAkMioddKMoGjJcAUmAJTYApMgSkwBabAFJgCU2AKTIEpMAWYAlNgCkyBKTAFpsAUmAJTYApMgSkwBaYAU2AKTIEpMAWmwBSYAlNgCkyBKTAFpsAUYApMgSkwBabAFJgCU2AKTIEpMAWmwBSYAkyBKTAFpsAUmAJTYApMgSkwBabAFJgCU4ApMAWmwBSYAlNgCkyBKTAFpsAUmAJTYApMAabAFJgCU2AKTIEp+GEBAAD//wMAlUMBxxeKhkkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client/noscreen_x.png
// module id = 1083
// module chunks = 114